import React from 'react';
import { Box, Typography } from '@mui/material';

type HeaderSectionProps = {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
};

export const HeaderSection: React.FC<HeaderSectionProps> = ({
  icon,
  title,
  children
}) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1.25 }}>
      {icon}
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ fontSize: '0.65rem', fontWeight: 600 }}
      >
        {title}
      </Typography>
    </Box>
    <Box sx={{ pl: 0.5 }}>{children}</Box>
  </Box>
);
